import { render } from "./LogoutConfirm.vue?vue&type=template&id=bd44d1be&scoped=true&ts=true"
import script from "./LogoutConfirm.vue?vue&type=script&lang=ts"
export * from "./LogoutConfirm.vue?vue&type=script&lang=ts"

import "./LogoutConfirm.vue?vue&type=style&index=0&id=bd44d1be&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd44d1be"]])

export default __exports__